import type { GridColDef } from "@mui/x-data-grid-premium";
import { useState } from "react";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import {
  DataGridColumnHeadersWithToolbar,
  DataGridHeaderToolbarProvider,
} from "@entrilia/shared/components/grid/DataGridColumnHeadersWithToolbar";
import { getRowSelectionModelFromIds, getSelectedRowIdsFromModel } from "@entrilia/shared/components/grid/gridHelper";
import type { LookupObjectReference } from "../../../../api/types/objectTypes";
import { getCheckedGridSx } from "../../../common/grid/gridStyles";
import { NameCell } from "./dataRequestTemplateCompaniesGridProvider";
import DataRequestTemplateCompaniesGridToolbar from "./DataRequestTemplateCompaniesGridToolbar";

const columnDefinitions: GridColDef<LookupObjectReference>[] = [
  {
    field: "primaryFieldValue",
    headerName: "Company",
    flex: 1,
    renderCell: ({ row }) => <NameCell row={row} />,
  },
];

const getRowId = (row: LookupObjectReference) => row.objectId;

interface Props {
  rows: LookupObjectReference[];
  hasPermissionsToManage: boolean;
  onRemoveCompanies: (ids: string[]) => void;
}

const DataRequestTemplateCompaniesGrid = ({ rows, hasPermissionsToManage, onRemoveCompanies }: Props) => {
  const [selectedRowIds, setSelectedRowIds] = useState<string[]>([]);

  const showToolbar = selectedRowIds.length > 0;

  return (
    <DataGridHeaderToolbarProvider
      showToolbar={showToolbar}
      selection={[selectedRowIds, setSelectedRowIds]}
      actions={
        <DataRequestTemplateCompaniesGridToolbar selectedIds={selectedRowIds} onRemoveCompanies={onRemoveCompanies} />
      }
    >
      <DataGrid<LookupObjectReference>
        rows={rows}
        columns={columnDefinitions}
        getRowId={getRowId}
        checkboxSelection={hasPermissionsToManage}
        rowSelectionModel={getRowSelectionModelFromIds(selectedRowIds)}
        onRowSelectionModelChange={(selection) => setSelectedRowIds(getSelectedRowIdsFromModel(selection))}
        sx={getCheckedGridSx}
        noRowsText="No companies"
        disableColumnReorder
        disableColumnSorting
        slots={{ columnHeaders: DataGridColumnHeadersWithToolbar }}
      />
    </DataGridHeaderToolbarProvider>
  );
};

export default DataRequestTemplateCompaniesGrid;
